var NotesCollection = require('../../../notes/models/notes.js'),
    NoteModelFactory = require('../factory/factory'),
    fvChannel = require('glRadio').channel('FV');


module.exports = NotesCollection.extend({

    // Currently not used but here in case
    url: function() {

        return fvChannel.request('apiUrl').docNotes( this.document );
    },

    model: function (attrs, options ) {

        var Note = NoteModelFactory.factory( attrs.noteType , true);
        return new Note( attrs, options );

    },

    parse: function(resp, options) {

        var availableNoteTypes = NoteModelFactory.noteTypesToInclude('document');

        // May want to move this logic to the NoteModel factory for clearer centralization
        !options.allowFlashNotes &&
            (availableNoteTypes = _.without(availableNoteTypes, 'FLASH_NOTE'));

        return _.filter(resp, function(n) {
            return _.contains(availableNoteTypes, n.noteType);
        });

    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/document/documentNotes.js
 ** module id = 397
 ** module chunks = 0
 **/